import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.scss';

const NotFound: React.FC = () => (
  <div className="not-found">
    <div className="not-found__code">404</div>
    <h1 className="not-found__title">Страница не найдена</h1>
    <p className="not-found__text">Возможно, ссылка устарела или адрес введён с ошибкой.</p>
    <div className="not-found__actions">
      <Link to="/" className="not-found__link not-found__link--solid">На главную</Link>
      <Link to="/tournaments" className="not-found__link">К турнирам</Link>
    </div>
  </div>
);

export default NotFound;
